// A "report this at most once per browser tab" memory, for telemetry reporters that run from
// several call sites and would otherwise send the same Sentry event many times for one
// condition. Cleared on tab reload, not on logout/login.
//
// Every instance registers itself below, so one test-only reset clears all of them. A reporter
// that adds a new dedup therefore cannot forget to reset it between test cases
// (df-270bf7ceaf06). Kept free of Angular DI so it loads under the ts-node ESM test loader.

export interface SessionDedup {
  // true the first time a key is seen (and remembers it), false every time after
  firstTimeFor(key: string): boolean;
}

const allSessionDedups: Set<string>[] = [];

export function createSessionDedup(): SessionDedup {
  const seen = new Set<string>();
  allSessionDedups.push(seen);
  return {
    firstTimeFor(key: string): boolean {
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    },
  };
}

// test-only: forget every key in every dedup created so far, so each test starts clean
export function _resetAllSessionDedupsForTesting(): void {
  for (const seen of allSessionDedups) seen.clear();
}
